export const TORONTO_BOARD_RESOURCE_CODE = 'Property:2381';
export const ITSO_BOARD_RESOURCE_CODE = 'Property:2984';

export const BOARD_RESOURCE_TO_NAME_MAP = {
  [TORONTO_BOARD_RESOURCE_CODE]: 'Toronto Regional Real Estate Board',
  [ITSO_BOARD_RESOURCE_CODE]: 'Information Technology Systems Ontario',
};
